import React, { useEffect, useState } from 'react'
import { FormattedRelativeTime } from 'react-intl'

import { styled } from '@mui/material/styles'

export interface IOwnProps {
    className?: string
    time: Date
    pickupX?: number
}

export type IProps = IOwnProps

const TimeStatus: React.FC<IProps> = (props) => {
    const { className, time, pickupX } = props
    const [showTimer, setShowTimer] = useState(false)

    const timeValue = () => time.getTime() / 1000 - Date.now() / 1000

    // console.log(
    //     'time',
    //     time,
    //     time.getTime() / 1000,
    //     currentTime.getTime() / 1000
    // )

    useEffect(() => {
        const interval = setInterval(() => {
            setShowTimer(
                !!pickupX && timeValue() > 0 && timeValue() / 60 > pickupX
            )
        }, 1000)
        return () => clearInterval(interval)
    }, [time, pickupX])
    // console.log('timeValue', timeValue() / 60)

    return showTimer ? (
        <></>
    ) : (
        <span className={className}>
            (
            <FormattedRelativeTime
                value={timeValue()}
                numeric='auto'
                updateIntervalInSeconds={1}
            />
            )
        </span>
    )
}

export default styled(TimeStatus)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.error.main,
}))
